import { askProductsResponseSchema, type AskProduct } from "@ttc-spectree/toolbox-contract/ask";
import { api } from "./client";

/**
 * Client for the SpecTree Toolbox Product Q&A products read (epic
 * PI-SPEC-SW-E310, features PI-SPEC-SW-1625 and PI-SPEC-SW-1628):
 * - `GET /toolbox/ask/products`  the products the caller may ask about
 *
 * The only SpecTree call Product Q&A makes: questions and answers stay on the
 * person's computer (Resolved Decision 10d). Parsed with the lenient contract
 * schema, so fields a newer SpecTree adds are kept or dropped, never fatal.
 */

interface DataResponse<T> {
  data: T;
}

/** The api client's base is `/api/v1`. */
export const ASK_PRODUCTS_API_PATH = "/toolbox/ask/products";

export const toolboxAskApi = {
  /** The products the caller may ask about (`ask` on their ADO project, or every configured project for an Admin). */
  listProducts: async (): Promise<AskProduct[]> => {
    const response = await api.get<DataResponse<unknown>>(ASK_PRODUCTS_API_PATH);
    return askProductsResponseSchema.parse(response.data).products;
  },
};

export type { AskProduct };
